module.exports = __webpack_public_path__ + "img/costs-coin.843e6295.svg";